module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-07.9c8093b3.png";